<template>
  <div class="misc-wrapper">
    <!-- Brand logo-->
    <b-link class="brand-logo">
      <div>
        <td style="vertical-align: middle;">
          <logo
            style="height: 50px; width: auto; margin-top: 0.15rem;"
          />
        </td>
        <td style="vertical-align: middle;">
          <h2
            class="brand-text text-primary"
            style="margin-top: 7px; margin-left: 0.5rem; text-align: center;"
          >
            {{ appName }}
          </h2>
        </td>
      </div>
    </b-link>
    <!-- /Brand logo-->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are not authorized! 🔐
        </h2>
        <p class="mb-2">
          You don’t have permission to access this page. Go Home!!
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          :to="loginRoute()"
        >Back to Home</b-button>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import Logo from '@/@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
    BButton,
    Logo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
      skin: store.state.appConfig.layout.skin,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(localStorage.getItem(`${$themeConfig.app.commonSession}-user-data`))
      return getHomeRouteForLoggedInUser(user ? user.role : null)
    },
  },
  setup() {
    const { appName } = $themeConfig.app

    return {
      appName,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
